import { Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CountUp } from './CountUp';

const GoogleRating = ({ 
  variant = 'default', 
  showReviewCount = true,
  className = '',
  animate = false
}) => {
  const { t } = useTranslation();
  const rating = 5.0;
  const reviewCount = 187;
  const googleReviewsUrl = "https://www.google.com/maps/place/Entrep%C3%B4t+Auto+Montr%C3%A9al/@45.4631,-73.5712,17z";

  const stars = Array(5).fill(0);

  if (variant === 'compact') {
    return (
      <a 
        href={googleReviewsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center gap-1.5 hover:opacity-80 transition-opacity ${className}`}
        title="Voir nos avis Google"
      >
        <div className="flex items-center">
          {stars.map((_, i) => (
            <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
          ))}
        </div>
        <span className="text-sm font-medium text-gray-700">{rating}</span>
        <img 
          src="https://www.google.com/favicon.ico" 
          alt="Google" 
          className="w-4 h-4"
        />
      </a>
    );
  }

  if (variant === 'light') {
    return (
      <a 
        href={googleReviewsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center gap-2 hover:opacity-80 transition-opacity ${className}`}
        title="Voir nos avis Google"
      >
        <div className="flex items-center">
          {stars.map((_, i) => (
            <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
          ))}
        </div>
        <span className="text-sm font-medium text-white/90">{animate ? <CountUp value="5.0" data-testid="home-google-rating" /> : rating}</span>
        <img 
          src="https://www.google.com/favicon.ico" 
          alt="Google" 
          className="w-4 h-4"
        />
      </a>
    );
  }

  // Default variant
  return (
    <a 
      href={googleReviewsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2 hover:opacity-80 transition-opacity ${className}`}
      title="Voir nos avis Google"
    >
      <div className="flex items-center">
        {stars.map((_, i) => (
          <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
        ))}
      </div>
      <span className="text-base font-semibold text-gray-800">{rating}</span>
      <img 
        src="https://www.google.com/favicon.ico" 
        alt="Google" 
        className="w-5 h-5"
      />
    </a>
  );
};

export default GoogleRating;
